import { useMemo } from 'react';

function useFormGroupAdapter(props) {
  const {
    children,
    className,
    componentClassName,
    position,
    help,
    id,
    input,
    inputComponent,
    label,
    meta,
    placeholder,
    required,
    onCustomChange,
    customComponent,
    isLabelInside = input.type === 'switch' || undefined,
    forceShowValidationError,
    ...rest
  } = useMemo(() => props, [props]);

  const { error, touched, submitError, dirtySinceLastSubmit } = useMemo(() => meta, [meta]);

  const invalid = useMemo(
    () => !!((error && (touched || forceShowValidationError)) || (submitError && !dirtySinceLastSubmit)),
    [dirtySinceLastSubmit, submitError, touched, error, forceShowValidationError],
  );

  const inputProps = useMemo(
    () => ({
      children,
      id: id || input.name,
      placeholder,
      ...input,
      ...rest,
      onChange: (...args) => {
        input.onChange(...args);
        if (onCustomChange) {
          onCustomChange(...args);
        }
      },
      isLabelInside,
      label: isLabelInside ? label : null,
      className: componentClassName,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [invalid, input, placeholder, isLabelInside],
  );

  const formGroupProps = useMemo(
    () => ({
      className,
      component: inputComponent,
      error: error || submitError,
      help,
      invalid,
      label,
      name: input.name,
      required,
      customComponent,
      position,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [invalid, input.name, error, submitError, label, help, submitError, className, required, customComponent],
  );

  return [formGroupProps, inputProps];
}

export default useFormGroupAdapter;
